// batch-queue.service.ts
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { timer } from 'rxjs';
import { take } from 'rxjs/operators';
import * as g from 'src/app/globals';

type PendingReq = {
  id: string;
  url: string;
  method: string;
  body?: any;
  headers: Record<string,string>;
  resolve: (v: any) => void;
  reject: (e: any) => void;
};

@Injectable({ providedIn: 'root' })
export class BatchQueueService {
  private queue: PendingReq[] = [];
  private ticking = false;

  // tune these
  private readonly windowMs = 15;       // buffer window
  private readonly maxBatch = 50;       // safety cap

  constructor(private http: HttpClient) {}

  enqueue(req: PendingReq) {
    this.queue.push(req);
    if (!this.ticking) {
      this.ticking = true;
      timer(this.windowMs).pipe(take(1)).subscribe(() => this.flush());
    }
    if (this.queue.length >= this.maxBatch) this.flush();
  }

  private flush() {
    this.ticking = false;
    const slice = this.queue.splice(0, this.maxBatch);
    if (slice.length === 0) return;

    const payload = {
      requests: slice.map(r => ({
        id: r.id,
        url: r.url,
        method: r.method,
        body: r.body,
        headers: r.headers,
      }))
    };

    const batchUrl = g.apiBaseUrl + 'DataStream/Post'; // your server endpoint
    const headers = new HttpHeaders({'x-batch-exempt':'1'}); // avoid re-intercepting
    this.http.post<any>(batchUrl, payload, { headers })
      .pipe(take(1))
      .subscribe({
        next: res => {
          const byId = new Map(res.responses?.map((x:any)=>[x.id, x]));
          slice.forEach(r => {
            const ans = byId.get(r.id) as any;
            if (!ans) return r.reject({ message: 'Missing sub-response', id: r.id });
            if (ans.status >= 200 && ans.status < 300) r.resolve(ans.body);
            else r.reject({ status: ans.status, body: ans.body, headers: ans.headers });
          });
        },
        error: err => {
          slice.forEach(r => r.reject(err));
        }
      });
  }
}
